import { render, staticRenderFns } from "./UnitCard.vue?vue&type=template&id=17fa6ace&"
import script from "./UnitCard.vue?vue&type=script&lang=js&"
export * from "./UnitCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports